import Vue from 'vue';
import VueRouter from 'vue-router';
import { doc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import HomeView from '../views/HomeView.vue';
import db from '../firebase';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true,
      nav: true,
    },
  },
  {
    path: '/question/:id',
    name: 'question',
    component: () => import('../views/Question.vue'),
    meta: {
      requiresAuth: true,
      nav: true,
    },
  },
  {
    path: '/lobby',
    name: 'lobby',
    component: () => import('../views/Lobby.vue'),
    meta: {
      requiresAuth: true,
      nav: false,
    },
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => import('../views/ThankYou.vue'),
    meta: {
      requiresAuth: true,
      nav: true,
    },
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('../views/Signin.vue'),
    meta: {
      nav: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// eslint-disable-next-line no-unused-vars
store.subscribe((mutation, state) => {
  if (mutation.type === 'SET_LOADING' && mutation.payload === false) {
    // store.dispatch('LOAD_QUESTIONS');
  }
});

const getCurrentUser = () => new Promise((resolve, reject) => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(
    auth,
    (user) => {
      unsubscribe();
      resolve(user);
    },
    reject,
  );
});

router.beforeEach(async (to, from, next) => {
  store.commit('SET_LOADING', true);
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const user = await getCurrentUser();
  if (requiresAuth) {
    if (!user) {
      next({ name: 'sign-in' });
    } else {
      const promises = [getDoc(doc(db, 'admin', 'admin'))];
      // const userDoc = await getDoc(userRef)
      const results = await Promise.all(promises);
      // store.commit('SET_ADMIN', results[0].data());
      // store.commit('SET_USER', results[1].data());

      // if (results[1].data().admin === true) next();
      console.log(results[0].data());
      if (results[0].data().completed === true) {
        console.log('here');
        if (to.name === 'thank-you') next();
        else next({ name: 'thank-you' });
      } else if (!results[0].data().started) {
        if (to.name === 'lobby') next();
        else next({ name: 'lobby' });
      } else if (to.name === 'home' || to.name === 'question') next();
      else next({ name: 'home' });
    }
  } else {
    next();
  }
  store.commit('SET_LOADING', false);
});

export default router;
